import React from "react";

const JitsiTeacher = props => {
  const jitsiContainerId = "jitsi-container-id";
  const [jitsi, setJitsi] = React.useState({});

  // Carrega o script do jitsi no html
  const loadJitsiScript = () => {
    let resolveLoadJitsiScriptPromise = null;

    const loadJitsiScriptPromise = new Promise(resolve => {
      resolveLoadJitsiScriptPromise = resolve;
    });

    const script = document.createElement("script");
    script.src = "https://meet.jit.si/external_api.js";
    script.async = true;
    script.onload = () => resolveLoadJitsiScriptPromise(true);
    document.body.appendChild(script);

    return loadJitsiScriptPromise;
  };

  const initialiseJitsi = async () => {
    if (!window.JitsiMeetExternalAPI) {
      await loadJitsiScript();
    }

    let opcoes = {
      parentNode: document.getElementById(jitsiContainerId),
      roomName: props.room, // Nome da sala: Turma-Professor-Disciplina
      interfaceConfigOverwrite: {
        SHOW_CHROME_EXTENSION_BANNER: false,
        APP_NAME: "Educandus",
        DEFAULT_LOGO_URL: "",
        JITSI_WATERMARK_LINK: "https://google.com",
        liveStreamingEnabled: false,

        TOOLBAR_BUTTONS: [
          "microphone",
          "camera",
          "closedcaptions",
          "desktop",
          "fullscreen",
          "fodeviceselection",
          "profile",
          // "chat",
          "etherpad",
          "sharedvideo",
          "settings",
          "videoquality",
          "filmstrip",
          "invite",
          "stats",
          "tileview",
          "select-background",
          "mute-everyone",
          "mute-video-everyone"
        ]
      },
      configOverwrite: {
        prejoinPageEnabled: false,
        startWithAudioMuted: true,
        startWithVideoMuted: true,
        fileRecordingsEnabled: true,
        dropbox: {
          appKey: "tg9ps5dsnx8bz1i",
          redirectURI: "https://meet.jit.si/static/oauth.html"
        },
        autoCaptionOnRecord: true
      },
      userInfo: {
        displayName: props.user
      }
    };

    // onde a mágica acontece
    let _jitsi = new window.JitsiMeetExternalAPI("meet.jit.si", opcoes);

    _jitsi.addEventListeners({
      recordingStatusChanged(data) {
        if (data.on === true) {
          props.onStartRecording();
        }
        if (data.on === false) {
          props.onStopRecording();
        }
      }
    });

    props.onJitsi(_jitsi);

    setJitsi(_jitsi);
  };

  React.useEffect(() => {
    initialiseJitsi();

    return () => jitsi?.dispose?.();
  }, []);

  return (
    <div
      id={jitsiContainerId}
      style={props.style}
      className={props.className}
    />
  );
};

export default JitsiTeacher;
